angular.module('ikeweb.locale').controller('LocaleChooserController', ['$scope', 'localeService',

    function($scope, localeService) {

        function getCurrentLocaleValue() {
            return localeService.getCurrentLocale().value;
        }

        function isCurrent(locale) {
            return getCurrentLocaleValue() === locale;
        }

        this.getAvailableLocales = localeService.getAvailableLocales;
        this.getCurrentLocale = getCurrentLocaleValue;
        this.setCurrentLocale = localeService.setCurrentLocale;
        this.isCurrent = isCurrent;
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/locale/chooser/chooser.controller.js
// module id = 484
// module chunks = 0